import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { CreditDetails } from "./Components/CreditDetails";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { SelectCreditRoleGroup } from "../../../../erp/CreditRoleGroup/SelectCreditRoleGroup";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    ConceptAnalist: string;
    Approve: string;
    IDReferencer: number;
    ApproveValue: number;
    NameReferenciado: string;
    CuotasApprove: number;
}

export const CC004 = ({ configProcedure }: Props) => {
    const { instance, bean, setBean } = useDataBean(_RequestCredit);

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        ConceptAnalist: "Capacidad de pago: $ xxx.000.000 a yy meses; novación, cuota xx/yy saldo $xxx, tiene crédito forpo cuota xx/xx saldo $xx, tiene descuento Banco xxx, es codeudor saldo xxx; antecedentes sin novedad; silf: cuenta xx – token: xx Cifin: Reporte xxxx, valor moro xxxx, comportamiento xxx días. Codeudor capacidad de pago: $ xxx.000.000 a 84 meses; tiene crédito forpo cuota xx/xx saldo $xx, tiene descuento Banco xxx, es codeudor saldo xxx; antecedentes sin novedad. Cifin: sin novedad.",
        IDReferencer: null,
        ApproveValue: 0,
        NameReferenciado: "",
        CuotasApprove: 0
    })

    const [props, setProps] = useState<any>({})

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            const x = configProcedure?._pocessData?.Props
            setProps(x)
            setResponse({ ...response, IDReferencer: x.IDReferencer })
        }
        getReuqest();
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        instance.updateRequestCredit({
            ...bean,
            AnalistConcep: response.ConceptAnalist,
            AmountApprove: response.ApproveValue,
            Cuotes: response.CuotasApprove,
        })

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(
                _single.jsonToBootstrapTable({
                    "Referenciador Asignado": response.NameReferenciado,
                    "Valor Aprobado": _single.formatMoney(response.ApproveValue),
                    "Concepto": response.ConceptAnalist,
                })
            )
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({ ApproveAnalist: response.Approve, IDReferencer: response.IDReferencer, ApproveValue: response.ApproveValue })
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

    }

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: string) => {
        if (response.ApproveValue > 0 && response.IDReferencer > 0) {
            setResponse(prev => ({ ...prev, Approve: app }));
        } else {
            toast.warning("Faltan datos en el formulario, Referenciado y/o Valor aprobación");
        }

    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                const x = resp[0].DataBeanProperties;
                setBean(x)
                setResponse({ ...response, ApproveValue: x.AmountCredit, CuotasApprove: x.Cuotes })
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const isChecklistValid = (jsonCheckList: any) => {
        if (!jsonCheckList || jsonCheckList === "") return false;

        try {
            const parsed = typeof jsonCheckList === "string" ? JSON.parse(jsonCheckList) : jsonCheckList;
            return Object.keys(parsed).length > 0;
        } catch (e) {
            return false;
        }
    };


    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 ">
                    <div className="row">
                        <div className="col-lg-4 d-flex justify-content-center">
                            <strong>Valor Solicitado:</strong>
                            <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.AmountCredit ?? 0, MASK_MONEY) }}></div>
                        </div>
                        <div className="col-lg-4 d-flex justify-content-center">
                            <strong>Cuotas:</strong>
                            <div dangerouslySetInnerHTML={{ __html: bean.Cuotes }}></div>
                        </div>
                        <div className="col-lg-4 d-flex justify-content-center">
                            <strong>Procentaje:</strong>
                            <div dangerouslySetInnerHTML={{ __html: `${bean.AmountTax} %` }}></div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <SelectCreditRoleGroup label="Referenciador" idSelector={response.IDReferencer} onChange={(e) => { setResponse({ ...response, "IDReferencer": e?.IDAccount, "NameReferenciado": e.AccountName }); console.log(e) }} returnType="Object" filterUser="IsReference" />
                </div>
                <div className="col-md-4">
                    <label>Cuotas Aprobadas</label>
                    <input type="number" className="form-control" value={response.CuotasApprove} onChange={(e) => { setResponse({ ...response, CuotasApprove: parseInt(e.target.value) }) }} />
                </div>
                <div className="col-md-4 mb-2">
                    <InputMoney _label="Valor Aprobado" _value={response.ApproveValue} onChange={(e) => { setResponse({ ...response, ApproveValue: e }) }} />
                </div>
                <div className="col-md-12">
                    <label>Concepto</label>
                    <textarea rows={6} className="form-control" value={response.ConceptAnalist} onChange={(e) => { setResponse({ ...response, ConceptAnalist: e.target.value }) }} />
                </div>

                <hr />

                <div className="col-md-12 mt-2">
                    <CreditDetails
                        objectUpdate={bean}
                        onUpdate={() => { getReuqest(); }}
                        pushInfo={(e) => { configProcedure?._pushInfo(e) }}
                        pushProps={(e) => configProcedure?._pushProps(e)}
                        Props={{
                            Codeudor: bean.JSONCodeuda ? JSON.parse(bean.JSONCodeuda) : {},
                            Credito: bean.JSONCredit ? JSON.parse(bean.JSONCredit) : {},
                            Notas: bean.JSONNotes ? JSON.parse(bean.JSONNotes) : {},
                            CheckList: bean.JSONCheckList ? JSON.parse(bean.JSONCheckList) : {},
                            JSONDeudor: bean.JSONDeudor ? JSON.parse(bean.JSONDeudor) : {},
                            RProps: props
                        }}
                    />
                </div>

                <div className="col-md-4 position-relative">
                    <div className="col-md-4">
                        <BasicButton
                            icon="ri-checkbox-circle-line"
                            eventClick={() => { updateForm("Referenciador") }}
                            disable={!isChecklistValid(bean.JSONCheckList)}
                        >
                            Enviar
                        </BasicButton>

                    </div>
                </div>

                <div className="col-md-4 d-flex justify-content-end position-relative">
                    <div className="col-md-4 d-flex justify-content-end">
                        <BasicButton
                            clase="danger"
                            icon="ri-close-circle-line"
                            eventClick={() => { updateForm("false") }}
                            disable={!isChecklistValid(bean.JSONCheckList)}
                        >
                            Archivar
                        </BasicButton>
                    </div>
                </div>
            </div>
        </>
    );
};